export const positiveNumbersOnly =
  (maxDecimal = 2) =>
  (value: string) => {
    let replacedValue = value
      .replace(/[^\d.,бю]/g, '')
      .replace(/[,бю]/g, '.')
      .split('.', 2)
      .join('.')

    replacedValue = replacedValue === '.' ? '0.' : replacedValue

    const re = new RegExp(`^(\\d)*(\\.)?([0-9]{0,${maxDecimal}})?`)
    return replacedValue.match(re)?.[0] ?? replacedValue
  }

export const digitsOnly = (value: string) => value.replace(/[^\d]/g, '')
